// extracted by mini-css-extract-plugin
export default {"imageContainer":"WSImage-module_imageContainer-QGwPy","image":"WSImage-module_image-zVBK9"};